import { FC } from "react";

import styles from './styles.module.scss'

import Logo from './logo.png'

export const Main: FC = () => {
    return (
        <div className={styles.main} id="ansar">
            <div className={styles.__in}>

                <div className={styles.info}>

                    <div className={styles.badge}>
                        Разработка • Образование • Инновации
                    </div>

                    <div className={styles.head}>
                        Ансариум
                    </div>

                    <div className={styles.sub_head}>
                        Мы создаем современные цифровые платформы и обучаем профессионалов IT
                    </div>

                    <div className={styles.button_box}>
                        <a href="#services">
                            <div className={styles.button + ' ' + styles.primary}>
                                Наши услуги
                            </div>
                        </a>
                        <a href="#courses">
                            <div className={styles.button + ' ' + styles.secondary}>
                                Обучение
                            </div>
                        </a>
                    </div>

                    <div className={styles.list}>

                        <div className={styles.li}>
                            <div className={styles.icon_wrapper}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M16.25 5L7.5 13.75L3.75 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div className={styles.name}>
                                Веб-приложения и платформы
                            </div>
                        </div>

                        <div className={styles.li}>
                            <div className={styles.icon_wrapper}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M16.25 5L7.5 13.75L3.75 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div className={styles.name}>
                                Образовательные проекты
                            </div>
                        </div>

                        <div className={styles.li}>
                            <div className={styles.icon_wrapper}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M16.25 5L7.5 13.75L3.75 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div className={styles.name}>
                                IT-обучение с нуля до эксперта
                            </div>
                        </div>

                        <div className={styles.li}>
                            <div className={styles.icon_wrapper}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M16.25 5L7.5 13.75L3.75 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div className={styles.name}>
                                Комплексные цифровые решения
                            </div>
                        </div>

                    </div>

                </div>

                <div className={styles.icon}>
                    <div className={styles.box}>
                        <div className={styles.glass_card}>
                            <div className={styles.image_container}>
                                <img src={Logo} alt="Ансариум" />
                            </div>
                            <div className={styles.glow}></div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}